import { useSelector } from 'react-redux'

import { useUserCompaniesQuery } from '../api/services/companiesApi'

// Single source of the "can this user switch company" rule (UserMenu + CompanySelect)
export const useCanSwitchCompany = () => {
  const user = useSelector((state) => state.user.user)

  const { data: companies } = useUserCompaniesQuery(user?.id, { skip: !user?.id })

  return { companies, canSwitch: companies?.length > 1 }
}
